<template>
    <span class="vue-navigation-link">
        <button
            v-if="isButton"
            @click="handleCLick"
            :aria-expanded="open ? 'true' : 'false'"
            :class="{'active': item.active}"
        >
            {{ item.title }}
        </button>

        <a v-if="!isButton"
           :href="item.url"
           :class="{'active': item.active}"
        >
            {{ item.title }}
        </a>
    </span>
</template>

<script>
export default {
    name: "NavigationLink",

    props: {
        item: {
            type: Object,
            required: true,
        },

        hasChildren: {
            type: Boolean
        },

        parentId: {
            type: null|String,
        },

        open: {
            type: Boolean,
        },

        activeId: {
            type: null|String,
        }
    },

    computed: {
        isButton() {
            return _.isEmpty(this.item.url) || this.hasChildren
        }
    },

    methods: {
        handleCLick() {
            let id = this.item.id;

            if (this.open) {
                id = null;
            }

            if (_.isEqual(this.activeId, this.item.id) && !lodash.isNil(this.parentId)) {
                id = this.parentId;
            }

            if (_.isEqual(this.activeId, this.item.id) && lodash.isNil(this.parentId)) {
                id = null;
            }

            this.$emit('navigation-link-clicked', {id})
        }
    }
}
</script>